Ext.define('WindowEmailConfig', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.konfiguracja_powiadomien,
    width: 950,
    height: 785,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: true,
    layout: 'fit',
    initComponent: function (config) {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'tabpanel',
            autoWidth: true,
            border: false,
            deferredRender: false,
            anchor: '0',
            activeTab: 0,
            scrollable: true,
            items: [{
                frame: false,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                autoDestroy: false,
                layout: 'fit',
                id: this.cid + 'emailtab',
                height: 550,
                hidden: true,
                disabled: true,
                items: [Ext.create('PanelEmailConfig', {
                    bodyStyle: 'padding:10px 10px 10px 10px',
                    id: this.cid + 'emailconfig'
                })]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showWOperator: function (obiektid) {
        this.operatorid = obiektid;
        this.showW();
    },
    showWOperatorGroup: function (obiektid) {
        this.idgrupaoperator = obiektid;
        this.showW();
    },
    showWFirma: function (obiektid) {
        this.idfirma = obiektid;
        this.showW();
    },
    showWGlobal: function () {
        this.showW();
    },
    showW: function () {
        sendAjaxDataJsonRpcL("rest/notifications/getObjectForEdit", {
            idoperator: this.operatorid,
            idfirma: this.idfirma,
            idgrupaoperator: this.idgrupaoperator
        }, this, function (data) {
            if (data.status) {
                this.obiekt = data.data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                sendAjaxDataJsonRpcL("rest/zbiorniki/getShortListForNotifications", {
                    idoperator: this.operatorid
                }, this, function (zbdata) {
                    if (zbdata.status) {
                        this.zbiornikData = zbdata.data;
                        if (this.obiekt && this.obiekt.notificationConfig) {
                            Ext.getCmp(this.cid + "emailconfig").loadNotificationConfig(this.obiekt, this.zbiornikData);
                        } else {
                            Ext.getCmp(this.cid + "emailconfig").loadZbiornikData(this.zbiornikData, []);
                        }
                        if (this.obiekt && this.obiekt.notificationParams) {
                            Ext.getCmp(this.cid + "emailconfig").loadNotificationParams(this.obiekt.notificationParams);
                        }
                        Ext.getCmp(this.cid + "emailtab").enable();
                    } else {
                        Ext.MessageBox.alert(Lang.error, zbdata.error);
                    }
                });
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    saveOp: function () {
        this.performSave();
    },
    performSave: function () {
        var emailconfig = Ext.getCmp(this.cid + "emailconfig").generateNotificationConfig();
        if (typeof (emailconfig) == "string") {
            Ext.MessageBox.alert(Lang.error, emailconfig);
        } else {
            var otherSettings = Ext.getCmp(this.cid + "emailconfig").getOtherSettings();
            sendAjaxDataJsonRpcL("rest/notifications/saveObject", {
                ...otherSettings, ...{
                    id: this.obiekt != null ? this.obiekt.id : null,
                    idoperator: this.operatorid,
                    idgrupaoperator: this.idgrupaoperator,
                    idfirma: this.idfirma,
                    optlockversion: this.obiekt == null ? null : this.obiekt.optlockversion,
                    notificationConfig: emailconfig
                }
            }, this, function (data) {
                if (data.status) {
                    this.close();
                } else {
                    Ext.MessageBox.alert(Lang.error, data.error);
                    return;
                }
                if (this.callbackF)
                    this.callbackF();
            }, 0);
        }
    },
    closeOp: function () {
        this.close();
    }
});
